<!-- 账户管理 -->
<template>
    <div class="container">
        <div class="content">
            <div>
                <Button
                    class="theme-bc mb24 theme-default-color"
                    @click="goModal"
                    >新增账号</Button
                >
                <Table :columns="columnsTable" :data="dataTable" border>
                    <template slot-scope="{ row }" slot="title">
                        <div>
                            {{
                                row.relation.length
                                    ? row.relation[0].group.title
                                    : ""
                            }}
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="status">
                        <div v-if="row.status == 1">正常</div>
                        <div v-if="row.status == 0">禁用</div>
                    </template>
                    <template
                        v-if="app_value7"
                        slot-scope="{ row }"
                        slot="is_association"
                    >
                        <Button
                            v-if="
                                row.agent_relation_count ||
                                row.store_relation_count ||
                                row.product_relation_count
                            "
                            @click="goAssociation(row)"
                            >{{ getRelationText(row) }}
                        </Button>
                        <Button v-else @click="goAssociation(row)"
                            >选择数据关联</Button
                        >
                    </template>
                    <template slot-scope="{ row }" slot="operate">
                        <div class="flex-sb">
                            <Button type="primary" ghost @click="goModal(row)"
                                >编辑</Button
                            >
                            <Button
                                v-if="row.status == 1"
                                type="primary"
                                ghost
                                @click="changeStatus(row)"
                                >禁用</Button
                            >
                            <Button
                                v-if="row.status == 0"
                                type="success"
                                ghost
                                @click="changeStatus(row)"
                                >启用</Button
                            >
                            <Button type="error" ghost @click="goDel(row)"
                                >删除</Button
                            >
                        </div>
                    </template>
                </Table>
            </div>
            <div class="mt24 ta-r">
                <Page
                    :current="storePrams.page"
                    :page-size="storePrams.limit"
                    :total="total"
                    show-elevator
                    show-total
                    @on-change="pageChange"
                />
            </div>
        </div>
        <!-- 新增/编辑 -->
        <Modal
            v-model="modals"
            :title="modalTitle"
            width="500"
            :mask-closable="false"
        >
            <div>
                <Form
                    ref="formData"
                    :model="formData"
                    label-position="right"
                    :label-width="100"
                    :rules="ruleValidate"
                >
                    <FormItem label="账户名称：" prop="user">
                        <Input
                            type="text"
                            v-model="formData.user"
                            placeholder="请输入账户名称"
                        ></Input>
                    </FormItem>
                    <FormItem label="手机号：" prop="phone">
                        <Input
                            type="text"
                            v-model="formData.phone"
                            placeholder="请输入手机号"
                        ></Input>
                    </FormItem>
                    <FormItem label="密码：" prop="password">
                        <Input
                            type="password"
                            v-model="formData.password"
                            placeholder="请输入密码"
                        ></Input>
                    </FormItem>
                    <FormItem v-if="app_value" label="质保卡激活：">
                        <i-switch
                            v-model="formData.activate_warranty"
                            size="large"
                            true-color="#FF761D "
                            :true-value="1"
                            :false-value="0"
                        >
                            <span slot="open">开启</span>
                            <span slot="close">关闭</span>
                        </i-switch>
                    </FormItem>
                    <FormItem label="分配角色：" prop="group">
                        <CheckboxGroup
                            v-model="formData.group"
                            v-for="(item, index) in roleList"
                            :key="index"
                        >
                            <Checkbox :label="item.id + ''"
                                ><span>{{ item.title }}</span></Checkbox
                            >
                        </CheckboxGroup>
                    </FormItem>
                </Form>
            </div>
            <div slot="footer">
                <Button @click="cancelForm">取消</Button>
                <Button
                    class="theme-bc ml24 theme-default-color"
                    @click="submitForm"
                    >确定</Button
                >
            </div>
        </Modal>
        <!-- 数据关联 -->
        <Drawer v-model="info_model" title="数据关联" width="70">
            <Menu
                mode="horizontal"
                :active-name="info_data.template_value"
                @on-select="selectTemplate"
            >
                <MenuItem name="1">代理商</MenuItem>
                <MenuItem name="2">门店</MenuItem>
                <MenuItem name="3">产品</MenuItem>
            </Menu>
            <div class="info-header">
                <Input
                    class="w300 mr24 mb24"
                    type="text"
                    v-model="info_data.keywords"
                    placeholder="搜索"
                    clearable
                ></Input>
                <Button
                    class="theme-bc mb24 theme-default-color"
                    icon="ios-search"
                    @click="goSearch"
                    >确认搜索</Button
                >
            </div>
            <Table
                height="600"
                ref="selection"
                :columns="columnsTemplate"
                :data="dataTemplate"
                border
                @on-selection-change="changeSelection"
            >
            </Table>
            <div class="info-footer">
                <Button
                    class="theme-bc theme-default-color ml12"
                    @click="submitInfo"
                    >确定</Button
                >
            </div>
        </Drawer>
    </div>
</template>

<script>
import {
    account_list,
    account_save,
    account_status,
    account_delete,
    account_roles_select,
    store_relation_list,
    agent_relation_list,
    product_relation_list,
    account_relation_agent,
    account_relation_store,
    account_relation_product,
} from "@/api/index";
export default {
    data() {
        return {
            storePrams: {
                page: 1,
                limit: 10,
            },
            total: 0,
            columnsTable: [
                { type: "index", width: 60, align: "center" },
                { title: "账户名称", key: "user", align: "center" },
                { title: "手机号", key: "phone", align: "center" },
                { title: "角色名称", slot: "title", align: "center" },
                { title: "状态", slot: "status", align: "center" },
                { title: "数据关联", slot: "is_association", align: "center" },
                { title: "创建时间", key: "created_at", align: "center" },
                {
                    title: "操作",
                    slot: "operate",
                    align: "center",
                    width: "300px",
                },
            ],
            dataTable: [],
            modals: false,
            modalTitle: "",
            formData: {
                id: "",
                user: "",
                password: "",
                phone: "",
                group: [],
                activate_warranty: 0,
            },
            ruleValidate: {
                user: [
                    {
                        required: true,
                        message: "请输入账户名称",
                        trigger: "blur",
                    },
                ],
                phone: [
                    {
                        required: true,
                        message: "请输入手机号",
                        trigger: "blur",
                    },
                ],
                password: [
                    { required: true, message: "请输入密码", trigger: "blur" },
                ],
            },
            roleList: [],
            app_ids: "",
            app_value: false,
            info_model: false,
            info_data: {
                template_value: "1",
                user_id: "",
                page: 1,
                limit: 999,
                keywords: "",
            },
            columnsTemplate: [],
            dataTemplate: [],
            delData: [],
            totalTemplate: 0,
            app_value7: false,
        };
    },
    created() {
        this.app_ids = localStorage.getItem("app_ids");
        this.app_value = this.app_ids.includes(10); // 检查是否包含10
        this.app_value7 = this.app_ids.includes(7); // 检查是否包含7
        if (this.app_value7) {
            this.columnsTable = [
                { type: "index", width: 60, align: "center" },
                { title: "账户名称", key: "user", align: "center" },
                { title: "手机号", key: "phone", align: "center" },
                { title: "角色名称", slot: "title", align: "center" },
                { title: "状态", slot: "status", align: "center" },
                { title: "数据关联", slot: "is_association", align: "center" },
                { title: "创建时间", key: "created_at", align: "center" },
                {
                    title: "操作",
                    slot: "operate",
                    align: "center",
                    width: "300px",
                },
            ];
        } else {
            this.columnsTable = [
                { type: "index", width: 60, align: "center" },
                { title: "账户名称", key: "user", align: "center" },
                { title: "手机号", key: "phone", align: "center" },
                { title: "角色名称", slot: "title", align: "center" },
                { title: "状态", slot: "status", align: "center" },
                { title: "创建时间", key: "created_at", align: "center" },
                {
                    title: "操作",
                    slot: "operate",
                    align: "center",
                    width: "300px",
                },
            ];
        }
    },
    mounted() {
        this.getList();
        this.getAccountRolesSelect();
    },
    methods: {
        getList() {
            account_list(this.storePrams)
                .then((res) => {
                    this.dataTable = res.data.data;
                    this.total = res.data.total;
                    // 删除后，page--
                    if (!res.data.data.length && this.storePrams.page != 1) {
                        this.storePrams.page--;
                        this.getList();
                    }
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        pageChange(index) {
            this.storePrams.page = index;
            this.getList();
        },
        getAccountRolesSelect() {
            account_roles_select()
                .then((res) => {
                    this.roleList = res.data;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        // Modal
        goModal(row) {
            if (row.id) {
                this.modalTitle = "编辑账号";
                this.formData.id = row.id;
                this.formData.user = row.user;
                this.formData.phone = row.phone;
                this.formData.group = row.group;
                this.formData.activate_warranty = row.activate_warranty;
            } else {
                this.modalTitle = "新增账号";
                this.formData.id = "";
                this.formData.user = "";
                this.formData.password = "";
                this.formData.phone = "";
                this.formData.group = [];
                this.formData.activate_warranty = 0;
            }
            this.modals = true;
        },
        cancelForm() {
            this.modals = false;
        },
        // 确定（提交表单）
        submitForm() {
            if (!this.formData.group.length) {
                this.$Message.error("请选择分配角色");
                return;
            }
            const phoneReg = /^1[3|4|5|6|7|8|9][0-9]{9}$/;
            if (!phoneReg.test(this.formData.phone)) {
                this.$Message.error("请输入正确的手机号码");
                return;
            }
            account_save(this.formData)
                .then((res) => {
                    this.getList();
                    this.modals = false;
                    this.$Message.success(res.msg);
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        // 修改账户状态
        changeStatus(row) {
            this.$Modal.confirm({
                title: "修改提示",
                content: "确认修改账户状态吗？",
                onOk: () => {
                    account_status({ id: row.id })
                        .then((res) => {
                            this.getList();
                            this.$Message.success(res.msg);
                        })
                        .catch((res) => {
                            this.$Message.error(res.msg);
                        });
                },
                onCancel: () => {},
            });
        },
        goDel(row) {
            this.$Modal.confirm({
                title: "删除提示",
                content: "确认删除吗？一经删除无法复原",
                onOk: () => {
                    account_delete({ id: row.id })
                        .then((res) => {
                            this.getList();
                            this.$Message.success(res.msg);
                        })
                        .catch((res) => {
                            this.$Message.error(res.msg);
                        });
                },
                onCancel: () => {},
            });
        },
        goAssociation(row) {
            this.info_data.template_value = "1";
            this.columnsTemplate = [
                { type: "selection", align: "center", width: 100 },
                { title: "ID", key: "id", align: "center" },
                { title: "代理商名称", key: "agent_name", align: "center" },
            ];
            this.info_data.user_id = row.id;
            this.getAgentRelationList();
            this.info_model = true;
        },
        submitInfo() {
            var ids;
            ids = this.delData
                .filter(
                    (item) => item && item.id !== undefined && item.id !== null
                )
                .map((item) => item.id);
            var data = {
                user_id: this.info_data.user_id,
                ids: ids,
            };
            if (this.info_data.template_value == 1) {
                account_relation_agent(data)
                    .then((res) => {
                        this.getList();
                        this.$Message.success(res.msg);
                    })
                    .catch((res) => {
                        this.$Message.error(res.msg);
                    });
            } else if (this.info_data.template_value == 2) {
                account_relation_store(data)
                    .then((res) => {
                        this.getList();
                        this.$Message.success(res.msg);
                    })
                    .catch((res) => {
                        this.$Message.error(res.msg);
                    });
            } else if (this.info_data.template_value == 3) {
                account_relation_product(data)
                    .then((res) => {
                        this.getList();
                        this.$Message.success(res.msg);
                    })
                    .catch((res) => {
                        this.$Message.error(res.msg);
                    });
            }
        },
        selectTemplate(name) {
            this.info_data.template_value = name;
            if (this.info_data.template_value == 1) {
                this.delData = [];
                this.columnsTemplate = [
                    { type: "selection", align: "center", width: 100 },
                    { title: "ID", key: "id", align: "center" },
                    { title: "代理商名称", key: "agent_name", align: "center" },
                ];
                this.info_data.page = 1;
                this.dataTemplate = [];
                this.getAgentRelationList();
            } else if (this.info_data.template_value == 2) {
                this.delData = [];
                this.columnsTemplate = [
                    { type: "selection", align: "center", width: 100 },
                    { title: "ID", key: "id", align: "center" },
                    { title: "门店名称", key: "name", align: "center" },
                ];
                this.info_data.page = 1;
                this.dataTemplate = [];
                this.getStoreRelationList();
            } else if (this.info_data.template_value == 3) {
                this.delData = [];
                this.columnsTemplate = [
                    { type: "selection", align: "center", width: 100 },
                    { title: "ID", key: "id", align: "center" },
                    { title: "产品名称", key: "product_name", align: "center" },
                ];
                this.info_data.page = 1;
                this.dataTemplate = [];
                this.getProductRelationList();
            }
        },
        // selection
        changeSelection(e) {
            this.delData = e;
        },
        // 代理商关联列表
        getAgentRelationList() {
            var data = {
                user_id: this.info_data.user_id,
                page: this.info_data.page,
                limit: this.info_data.limit,
                keywords: this.info_data.keywords,
            };
            agent_relation_list(data)
                .then((res) => {
                    this.dataTemplate = res.data;
                    this.dataTemplate = this.dataTemplate.map((item) => {
                        if (item.has_relation === 1) {
                            return {
                                ...item,
                                _checked: true,
                            };
                        }
                        return item;
                    });
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        // 门店关联列表
        getStoreRelationList() {
            var data = {
                user_id: this.info_data.user_id,
                page: this.info_data.page,
                limit: this.info_data.limit,
                keywords: this.info_data.keywords,
            };
            store_relation_list(data)
                .then((res) => {
                    this.dataTemplate = res.data;
                    this.dataTemplate = this.dataTemplate.map((item) => {
                        if (item.has_relation === 1) {
                            return {
                                ...item,
                                _checked: true,
                            };
                        }
                        return item;
                    });
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        // 产品关联列表
        getProductRelationList() {
            var data = {
                user_id: this.info_data.user_id,
                page: this.info_data.page,
                limit: this.info_data.limit,
                keywords: this.info_data.keywords,
            };
            product_relation_list(data)
                .then((res) => {
                    this.dataTemplate = res.data;
                    this.dataTemplate = this.dataTemplate.map((item) => {
                        if (item.has_relation === 1) {
                            return {
                                ...item,
                                _checked: true,
                            };
                        }
                        return item;
                    });
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        goSearch() {
            if (this.info_data.template_value == 1) {
                this.columnsTemplate = [
                    { type: "selection", align: "center", width: 100 },
                    { title: "ID", key: "id", align: "center" },
                    { title: "代理商名称", key: "agent_name", align: "center" },
                ];
                this.info_data.page = 1;
                this.dataTemplate = [];
                this.getAgentRelationList();
            } else if (this.info_data.template_value == 2) {
                this.columnsTemplate = [
                    { type: "selection", align: "center", width: 100 },
                    { title: "ID", key: "id", align: "center" },
                    { title: "门店名称", key: "name", align: "center" },
                ];
                this.info_data.page = 1;
                this.dataTemplate = [];
                this.getStoreRelationList();
            } else if (this.info_data.template_value == 3) {
                this.columnsTemplate = [
                    { type: "selection", align: "center", width: 100 },
                    { title: "ID", key: "id", align: "center" },
                    { title: "产品名称", key: "product_name", align: "center" },
                ];
                this.info_data.page = 1;
                this.dataTemplate = [];
                this.getProductRelationList();
            }
        },
        getRelationText(row) {
            // 1. 初始化数组，存放所有有值的文本片段
            const relationParts = [];
            // 2. 逐个判断，有值则添加纯文本片段（不再手动加 /）
            if (row.agent_relation_count) {
                relationParts.push(`代理商(${row.agent_relation_count})`);
            }
            if (row.store_relation_count) {
                relationParts.push(`门店(${row.store_relation_count})`);
            }
            if (row.product_relation_count) {
                relationParts.push(`产品(${row.product_relation_count})`);
            }
            // 3. 用 / 连接数组中的所有片段，无数据则返回空字符串
            return relationParts.join("/");
        },
    },
};
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
}
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    height: 100%;
}
.footer {
    position: absolute;
    right: 20px;
    bottom: 20px;
}
.ta-r {
    text-align: right;
}
.info-footer {
    position: absolute;
    left: 0;
    bottom: 0;
    padding: 24px;
    background-color: #fff;
    width: 100%;
    text-align: right;
    border-top: 1px solid #ccc;
}
.info-header {
    margin: 24px 0 0 0;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}
::v-deep .ivu-radio-group-button .ivu-radio-wrapper-checked {
    background: #53c41a;
    border-color: #53c41a;
    box-shadow: -1px 0 0 0 #53c41a;
    border-radius: 5px;
    color: #fff;
    z-index: 1;
}
::v-deep .ivu-checkbox {
    margin-right: 12px;
}
::v-deep .ivu-checkbox-checked .ivu-checkbox-inner {
    border-color: #ff761d;
    background-color: #ff761d;
}
/* 表头背景颜色 */
::v-deep .ivu-table-header thead tr th {
    background: rgba(198, 44, 44, 0) !important;
    box-shadow: 0px 1px 0px 0px rgba(234, 234, 234, 0.99);
}
/* 表头字体颜色 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-weight: bold;
}
/* table中所有的边框  */
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-menu-item {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 18px;
    color: #484e66;
}
::v-deep .ivu-menu-item:hover {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 18px;
    color: #ff761d !important;
    border-bottom: 2px solid #ff761d !important;
}
::v-deep .ivu-menu-item.ivu-menu-item-active.ivu-menu-item-selected {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 18px;
    color: #ff761d !important;
    border-bottom: 2px solid #ff761d !important;
}
</style>